<div id="content" class="extensible">
  <div class="page-title">
    <app-company-product-page-identity />
    <h1>{{ page_title }}</h1>
    @if (is_product_manager) {
      <button mat-flat-button color="accent" (click)="openCreateConfigurationDialog()">
        <mat-icon matPrefix>settings</mat-icon>
        Configurar Notificaciones
      </button>
    }
  </div>

  @if (has_bot_not_member_conversation()) {
    <div class="bot-membership-warning" role="status">
      <mat-icon aria-hidden="true">warning</mat-icon>
      <p>
        Hay conversaciones de notificación de despliegues (o el canal interno) donde el bot de Bisual no está añadido. Sin eso no se
        enviarán avisos. Revisa la configuración e invita al bot en Slack.
      </p>
    </div>
  }

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>
      <mat-form-field style="max-width: 200px">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="status">
          <mat-option value="">Todos</mat-option>
          <mat-option value="pending">Pendiente</mat-option>
          <mat-option value="running">En ejecución</mat-option>
          <mat-option value="success">Exitoso</mat-option>
          <mat-option value="failure">Fallido</mat-option>
          <mat-option value="cancelled">Cancelado</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let deploy">
            <span>{{ deploy.created_at | date: 'short' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="application">
          <th mat-header-cell *matHeaderCellDef>Aplicación</th>
          <td mat-cell *matCellDef="let deploy">
            <span>{{ deploy._display.applicationName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="branch_env_tag">
          <th mat-header-cell *matHeaderCellDef>Entorno / Branch / Tag</th>
          <td mat-cell *matCellDef="let deploy">
            <div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center">
              @if (deploy._display.environmentRole) {
                <mat-chip [class]="deploy._display.environmentRoleClass" style="font-size: 12px; height: 24px">
                  {{ deploy._display.environmentRoleLabel }}
                </mat-chip>
              }
              @if (deploy._display.branch) {
                <span
                  style="font-family: monospace; font-size: 12px; color: #666; padding: 2px 8px; background: #f5f5f5; border-radius: 4px"
                >
                  {{ deploy._display.branch }}
                </span>
              }
              @if (deploy._display.tag) {
                <span
                  style="
                    font-family: monospace;
                    font-size: 12px;
                    color: #1976d2;
                    padding: 2px 8px;
                    background: #e3f2fd;
                    border-radius: 4px;
                    font-weight: 500;
                  "
                >
                  {{ deploy._display.tag }}
                </span>
              }
              @if (!deploy._display.environmentRole && !deploy._display.branch && !deploy._display.tag) {
                <span style="color: #999">-</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let deploy">
            <mat-chip [class]="deploy._display.statusChipClass">
              {{ deploy._display.statusLabel }}
            </mat-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let deploy">
            <span>{{ deploy.user?.full_name || 'Desconocido' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tasks">
          <th mat-header-cell *matHeaderCellDef>Tareas</th>
          <td mat-cell *matCellDef="let deploy">
            <span>{{ deploy._display.taskCodes }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let deploy; let i = index">
            <button mat-icon-button [routerLink]="[deploy.id]">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
